import { withFormik } from 'formik';
import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';
import { Button, Card, Checkbox, Form, Header, Item } from 'semantic-ui-react';
import yup from 'yup';
import Field from './../Field';
import AirlineDropdown from './../dropdowns/AirlineDropdown';
import AirportDropdown from './../dropdowns/AirportDropdown';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as messageActions from '../../actions/message-actions';
import DateAndTimeInputs, { noUTC, notEqual } from './../DateAndTimeInputs';
import { CreateDelayedFlight } from "../../mutations/CreateDelayedFlight";
import { MatchFlightWithDelayedFlight } from "../../mutations/MatchFlightWithDelayedFlight";
import { CurrentTicket } from '../../queries/CurrentTicket';

const initialForm = {
  airline: '',
  flightNo: '',
  airportOrigin: '',
  airportDestination: '',
  actualDeparture: undefined,
  actualArrival: undefined,
  scheduledDeparture: undefined,
  scheduledArrival: undefined,
  diverted: false,
  cancelled: false,
  recovered: false
}

const ERROR_REQUIRED = 'This field is required'
const ERROR_NUMBER = 'Must be a number'

class AddDelayedFlight extends Component {

  handleBlur = (name) => this.props.setFieldTouched(name, true)
  handleChange = (e, { name, value }) => {
    this.props.setFieldValue(name, value);
  };
  handleCheckboxChange = (e, { name, checked }) => {
    this.props.setFieldValue(name, checked);
  };

  handleCopyScheduled = () => {
    const { setFieldValue, values } = this.props;
    setFieldValue('actualDeparture', values.scheduledDeparture)
    setFieldValue('actualArrival', values.scheduledArrival)
  }

  dateTimeWrapper = (name, text) => {
    const { values, errors, touched } = this.props;
    return (
      <DateAndTimeInputs
        value={values[name]}
        errors={errors[name]}
        touched={touched[name]}
        handleBlur={this.handleBlur.bind(this, name)}
        setFieldValue={this.props.setFieldValue}
        name={name}
        text={text}
      />
    )
  }

  render = () => {
    const { isSubmitting, errors, touched, flight, values } = this.props;
    const CHECKBOX_OPTIONS = [
     {label: 'diverted', value: 'diverted'},
     {label: 'cancelled', value: 'cancelled'},
     {label: 'recovered', value: 'recovered'}
    ]
    return (
      <Item.Group>
        <Item>
          <Item.Content>
            <Form loading={isSubmitting}>
              <Card fluid>
                <Card.Content>
                  <Header as="h4">Flight {flight.id}</Header>
                  <Form.Group>
                    <Field
                      error={errors.airline}
                      touched={touched.airline}
                      width={4}
                    >
                      <AirlineDropdown
                        onBlur={this.handleBlur}
                        onChange={this.handleChange}
                        value={values.airline}
                        labelled
                      />
                    </Field>
                    <Field
                      error={errors.flightNo}
                      touched={touched.flightNo}
                      width={2}
                    >
                      <Form.Field
                        label="Flight number"
                      />
                      <Form.Input
                        style={{ opacity: 1 }}
                        name="flightNo"
                        placeholder="Flight number"
                        value={values.flightNo}
                        maxLength={5}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur.bind(this, 'flightNo')}
                      />
                    </Field>

                  </Form.Group>
                  <Form.Group>

                    <Field
                      error={errors.airportOrigin}
                      width={4}
                      touched={touched.airportOrigin}
                    >
                      <AirportDropdown
                        name="airportOrigin"
                        label="Airport Origin"
                        placeholder="Airport Origin"
                        value={values.airportOrigin}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur.bind(this, 'airportOrigin')}
                      />
                    </Field>
                    <Field
                      error={errors.airportDestination}
                      width={4}
                      touched={touched.airportDestination}
                    >
                      <AirportDropdown
                        name="airportDestination"
                        label="Airport Destination"
                        placeholder="Airport Destination"
                        value={values.airportDestination}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur.bind(this, 'airportDestination')}
                      />
                    </Field>

                  </Form.Group>
                  <Form.Group>
                    {this.dateTimeWrapper("scheduledDeparture", "Scheduled departure")}
                    {this.dateTimeWrapper("scheduledArrival", "Scheduled arrival")}

                  </Form.Group>

                  <Form.Group>
                    {this.dateTimeWrapper("actualDeparture", "Actual departure")}
                    {this.dateTimeWrapper("actualArrival", "Actual arrival")}

                    <Button size="small" onClick={this.handleCopyScheduled}>
                      copy scheduled
                    </Button>
                  </Form.Group>
                  <Form.Group>
                  {CHECKBOX_OPTIONS.map( ({label, value}, i) => (
                    <React.Fragment key={i}>
                      <Field
                      error={errors[value]}
                      touched={touched[value]}
                      >
                      <Checkbox
                        label={label}
                        name={value}
                        checked={values[value]}
                        onChange={this.handleCheckboxChange}
                        onBlur={this.handleBlur.bind(this, value)} />
                      </Field>
                    </React.Fragment>
                    ))}
                  </Form.Group>
                  <Form.Group>
                    <Button
                      primary
                      size="mini"
                      floated="right"
                      name='Flight'
                      className="c-TicketDetails__add-btn"
                      content={"Save"}
                      onClick={this.props.handleSubmit}
                      type='submit'
                    />
                    <Button
                      color='red'
                      size="mini"
                      floated="right"
                      name='Cancel'
                      className="c-TicketDetails__add-btn"
                      content={"Cancel"}
                      onClick={() => { this.props.resetForm(); this.props.cancelEdit() }}
                    />
                  </Form.Group>
                </Card.Content>
              </Card>
            </Form>
          </Item.Content>
        </Item>
      </Item.Group>
    )
  }
}

const formikConfig = {
  enableReinitialize: true,
  mapPropsToValues: props => {

    return ({
      ...initialForm,
      airline: props.flight.airline.iata,
      flightNo: props.flight.number,
      scheduledDeparture: noUTC(props.flight.localDepartureDate),
      scheduledArrival: noUTC(props.flight.localArrivalDate),
      airportDestination: props.flight.airportDestination.iata,
      airportOrigin: props.flight.airportOrigin.iata
    })
  },
  validationSchema: () => {
    yup.addMethod(yup.string, 'notEqual', notEqual);
    return yup.object().shape({
      airline: yup.string().required(ERROR_REQUIRED),
      flightNo: yup.number().typeError(ERROR_NUMBER).required(ERROR_REQUIRED).integer(),
      cancelled: yup.boolean(),
      scheduledDeparture: yup.string().required(ERROR_REQUIRED),
      scheduledArrival: yup.string().notEqual(yup.ref('scheduledDeparture'), 'Scheduled Arrival and Scheduled Departure dates cannot be equal').required(ERROR_REQUIRED),
      actualDeparture: yup.string().required(ERROR_REQUIRED),
      actualArrival: yup.string().when('cancelled', (cancelled, schema) => {
        if (!cancelled) {
          return schema.notEqual(yup.ref('actualDeparture'), 'Actual Arrival and Actual Departure dates cannot be equal').required("Arrival is required if the flight was not cancelled")
        }
        return schema.max(0, "Arrival should be empty if the flight was cancelled")
      }),
      airportDestination: yup.string().required(ERROR_REQUIRED),
      airportOrigin: yup.string().required(ERROR_REQUIRED)
    })
  },
  handleSubmit: (values, { props, setSubmitting, setErrors, resetForm }) => {

   props.CreateDelayedFlight({
     variables: {
       input: {
         delayedFlight: {
           number: values.flightNo,
           airlineCode: values.airline,
           airportOriginCode: values.airportOrigin,
           airportDestinationCode: values.airportDestination,
           recovered: values.recovered,
           cancelled: values.cancelled,
           diverted: values.diverted,
           localScheduledDepartureDate: values.scheduledDeparture,
           localScheduledArrivalDate: values.scheduledArrival,
           localActualDepartureDate: values.actualDeparture,
           localActualArrivalDate: values.actualArrival
         }
       }
     }
   }).then(({ data }) => {
     setErrors({})
       props.MatchFlightWithDelayedFlight({
         variables: {
           input: { flightId: props.flight.id }
          },
          refetchQueries: [{
            query: CurrentTicket,
            variables: {
              id: props.passengerTicketId
            }
          }]
       })
       .then(({data}) => {
         if (data) {
           props.actions.showMessage({
             header: 'Flight matched!',
             text: `Flight was created and matched`,
             props: { success: true },
             duration: 4000
           }); 
         }
         setSubmitting(false)
         props.onFlightCreated()
       })
       .catch( err => {
         props.actions.showMessage({
           header: 'Flight not matched ...',
           text: `Flight was created but not matched or meanwhile was matched by someone else.`,
           props: { success: false },
           duration: 4000
         });
         setSubmitting(false)
        })
     resetForm()
   }).catch((error) => {
     console.dir(error)
     setErrors({ serverError: error })
     setSubmitting(false)
   });
  }
}

const AddDelayedFlightWithData = compose(
  connect(null, dispatch => ({
    actions: bindActionCreators(messageActions, dispatch)
  })),
  graphql(CreateDelayedFlight, { name: 'CreateDelayedFlight' }),
  graphql(MatchFlightWithDelayedFlight, { name: 'MatchFlightWithDelayedFlight'} ),
  withFormik(formikConfig),
)(AddDelayedFlight)

export default AddDelayedFlightWithData;


// WEBPACK FOOTER //
// ./src/component/FlightView/AddDelayedFlight.js